import React from "react"; 

import { ReactComponent as BrainLogo } from "../../assets/images/icon.svg";

export const HeaderLogo = () => {
  return (
    <div>
       <BrainLogo style={{ width: "100%", height: "100%" }} />
    </div>
  );
};
